import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Login } from "./pages/Login";
import { AdminLayout } from "./components/layout/AdminLayout";
// import { Dashboard } from "./pages/Dashboard";
import { ApplicationsList } from "./pages/applications/ApplicationsList";
import { ApplicationDetails } from "./pages/applications/ApplicationDetails";
import { PaymentsList } from "./pages/payments/PaymentsList";
import { SearchResults } from "./pages/SearchResults";
import { RenewList } from "./pages/renew/RenewList";
import { RenewDetails } from "./pages/renew/RenewDetails";
import { ContactMessages } from "./pages/ContactMessages";
import { ReviewsList } from "./pages/review/ReviewsList";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public Routes - Login is accessible without authentication */}
          <Route path="/login" element={<Login />} />
          {/* Protected Admin Routes - All routes under / require authentication */}
          <Route path="/" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            {/* <Route index element={<Dashboard />} /> */}

            <Route index element={<ApplicationsList />} />
            
            {/* Applications */}
            <Route path="applications">
              <Route index element={<ApplicationsList />} />
              <Route path=":id" element={<ApplicationDetails />} />
              <Route path="pending" element={<ApplicationsList filter="pending" />} />
            </Route>

            <Route path="renew">
              <Route index element={<RenewList />} />
              <Route path=":id" element={<RenewDetails />} />
            </Route>

            {/* Payments */}
            <Route path="payments">
              <Route index element={<PaymentsList />} />
              <Route path="pending" element={<PaymentsList filter="pending" />} />
            </Route>

            <Route path="contact-messages" element={<ContactMessages />} />

            <Route path="reviews" element={<ReviewsList />} />

            <Route path="search" element={<SearchResults />} />
          </Route>

          {/* Catch all - redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
